import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// This component was inspired by this article. https://medium.com/hackernoon/using-a-react-16-portal-to-do-something-cool-2a2d627b0202

function copyStyles(sourceDoc, targetDoc) {
  Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
    const styleElement = sourceDoc.createElement('style');
    Array.from(styleSheet.cssRules).forEach((cssRule) => {
      styleElement.appendChild(sourceDoc.createTextNode(cssRule.cssText));
    });
    targetDoc.head.appendChild(styleElement);
  });
}

class DoorLauncher extends React.PureComponent {
  constructor(props) {
    super(props);
    this.container = document.createElement('div'); // create a new container element to render child components inside
    this.newTab = null;
  }

  componentDidMount() {
    const { title } = this.props;
    // create a new browser tab, insert the new container element from the constructor, set the tab title and bring in styles from parent page.
    this.newTab = window.open();
    this.newTab.document.body.appendChild(this.container);
    this.newTab.document.title = title;
    copyStyles(document, this.newTab.document);
  }

  render() {
    // Use ReactDOM Portals to render any child components inside the container created in the constructor.
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.container);
  }
}

DoorLauncher.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
};
DoorLauncher.defaultProps = {
  title: `PremiSys\u00AE`,
};
export default DoorLauncher;
